// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"189": "5ba30207d9fa4047","26": "892673f23e2b4c30",}[chunkId] + ".js"
}